
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { fetchLeadershipPage } from "../../services/api";

export default function KeyProgram({ lang }) {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
  const loadData = async () => {
    setLoading(true);
    try {
      const enData = await fetchLeadershipPage("en");
      let source = enData;

      if (lang !== "en") {
        const localData = await fetchLeadershipPage(lang);
        
        // Only use local data if it's a valid object with content
        const hasLocalData =
          localData &&
          !Array.isArray(localData) &&
          Object.keys(localData).length > 0;

        source = hasLocalData ? localData : enData;
      }

      // Always use English as page level fallback
      setPageData(source || enData);

      const programs = source?.Key_Programs?.length
        ? source.Key_Programs
        : enData?.Key_Programs;

      if (programs) {
        const mapped = programs.map((program, index) => {
          const enProgram = enData?.Key_Programs?.[index];
          const imageUrl = program.Image?.url || enProgram?.Image?.url;

          return {
            id: program.id,
            title: `Program ${index + 1}`,
            text: program.Section_Heading || enProgram?.Section_Heading,
              find_url: program.Find_Out_More_url || enProgram?.Find_Out_More_url,
                find_More: program.Find_Out_More || enProgram?.Find_Out_More,
            img: imageUrl
              ? `${(process.env.REACT_APP_Base_URL || "http://localhost:1337").replace("/api", "")}${imageUrl}`
              : `/img${index + 1}.jpg`,
            linkText: program.Find_Out_How || enProgram?.Find_Out_How,
            linkUrl: program.Find_Out_How_url || enProgram?.Find_Out_How_url,
          };
        });
        setSlides(mapped);
      }
    } catch (err) {
      console.error("Error loading key programs:", err);
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, [lang]);

  const current = slides[activeIndex];

  if (loading) return <div>Loading...</div>;
  if (!slides.length) return <div>No programs found.</div>;

  return (
    <div className="padding-x-40 padding-y-80 custom-lg-flex">
      {/* LEFT CONTENT */}
      <div className="custom-w-51 contact-wrapper">
        <div>
          <div className="section-name-wrapper">
            <div className="section-name-dot"></div>
            <h6 className="section-name">
              {pageData?.Key_Program_Section_Name}
            </h6>
          </div>

          <h3 className="size-h3 pr-5 pt-2.5 text-dark-blue-color" style={{ marginBottom: "0" }}>
            {current.text}
          </h3>

          <p className="pt-2 text-dark-blue-color"></p>
        </div>
<a
   href={current.find_url}
  target="_blank"
  rel="noopener noreferrer"
  className="size-h3 pt-1 underline text-accent-blue"
  style={{marginBottom:0}}
>
  {current.find_More ?? "Find out more"}
</a>
</div>

      {/* RIGHT IMAGE */}
      <div className="custom-w-48 ">
        <div className="overflow-hidden rounded-[10px] pt-[40px] md:pt-0">
          <img
            style={{ height: "520px", objectFit: "cover" }}
            src={current.img}
            className="w-full rounded-[5px] hover:scale-110 transition-transform duration-300"
            alt="img"
          />
        </div>
        {slides.length > 1 && (
        <div className="flex gap-4 mt-4 items-center pb-2.5">
          {slides.map((slide, index) => (
            <span
              key={slide.id}
              onClick={() => setActiveIndex(index)}
              style={{
                color: "rgba(0, 64, 152, 1)",
                padding: "15px 15px 10px 15px",
                border: "1px solid rgba(25, 175, 225)",
                borderRadius: "5px",
                lineHeight: 1,
              }}
              className={`cursor-pointer text-sm font-semibold transition-all duration-200 ${
                activeIndex === index ? "opacity-100" : "opacity-[0.3]"
              }`}
            >
              {index + 1}
            </span>
          ))}
        </div>
        )}
      </div>
    </div>
  );
}